import { mutator } from 'satcheljs';
import { showProjectsToolbox, hideProjectsToolbox, selectAsset } from '../actions';
import { openTimeStreamProject } from 'owa-timestream-store';
import getStore from '../store';

mutator(showProjectsToolbox, () => {
    getStore().showProjectsToolbox = true;
});

mutator(hideProjectsToolbox, () => {
    getStore().showProjectsToolbox = false;
});

mutator(openTimeStreamProject, () => {
    getStore().showProjectsToolbox = false;
});

mutator(selectAsset, _ => {
    getStore().showProjectsToolbox = false;
});
